import PackageIcon from 'assets/package.png'
import ArchiveIcon from 'assets/archive.png'
import ManualGearboxIcon from 'assets/manual-gearbox.png'
import { OPERATION_MODE_CODES } from 'core/domain/operationModeConstants'

interface Props {
    packages?: number
    containers?: number
    chutes?: number
    operationModeCode?: string
    containerCode?: string
    centered?: boolean
}

const OrderSummaryPill = ({ packages, containers, chutes, operationModeCode, containerCode, centered }: Props) => {
    // Modo container code: muestra solo el código del contenedor
    if (containerCode) {
        return (
            <div className={`inline-flex items-center gap-1 bg-gray-100 rounded-full px-[8px] py-[6px] h-[28px] ${centered ? 'mx-auto' : ''}`}>
                <img src={ArchiveIcon} alt="container" className="w-4 h-4" />
                <span className="text-sm font-normal leading-[18px] text-[#3E5060]">{containerCode}</span>
            </div>
        )
    }

    // Modo summary: muestra paquetes, containers y opcionalmente chutes
    return (
        <div className={`inline-flex items-center gap-4 bg-gray-100 rounded-full px-[8px] py-[6px] h-[28px] ${centered ? 'mx-auto' : ''}`}>
            <div className="flex items-center gap-1 text-sm text-[#3E5060]">
                <img src={PackageIcon} alt="packages" className="w-4 h-4" />
                <span className="font-normal leading-[18px]">{packages ?? 0}</span>
            </div>

            <div className="flex items-center gap-1 text-sm text-[#3E5060]">
                <img src={ArchiveIcon} alt="containers" className="w-4 h-4" />
                <span className="font-normal leading-[18px]">{containers ?? 0}</span>
            </div>

            {operationModeCode !== OPERATION_MODE_CODES.CLASSIFICATION && (
                <div className="flex items-center gap-1 text-sm text-[#3E5060]">
                    <img src={ManualGearboxIcon} alt="chutes" className="w-4 h-4" />
                    <span className="font-normal leading-[18px]">{chutes ?? 0}</span>
                </div>
            )}
        </div>
    )
}

export default OrderSummaryPill
